import { Typography, Button } from "@mui/material";
import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import MainLayout from "../layouts/Mainlayout";
import logo from "../assets/vanadevrai.png";
import { getActivities, getImagesByActivity } from "../services/api";
import { toast } from "react-toastify";
import { Modal, Box } from "@mui/material";
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import { CircularProgress } from "@mui/material";
import img1 from "../assets/imageOne.jpeg";
import img2 from "../assets/imageTwo.jpeg";
import img3 from "../assets/ImageThree.jpeg";
import img4 from "../assets/imageFour.jpeg";
import img5 from "../assets/imageFive.jpeg";

export default function Home() {
  const [activities, setActivities] = useState([]);
  const [open, setOpen] = useState(false);
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);

const handleOpen = async (activityId) => {
  try {
    setLoading(true);
    const res = await getImagesByActivity(activityId);
    setImages(res.data);
    setOpen(true);
  } catch (err) {
    toast.error("Failed to load images ❌");
  } finally {
    setLoading(false);
  }
};

useEffect(() => {
  const fetchActivities = async () => {
    try {
      const res = await getActivities();
      setActivities(res.data);
    } catch (error) {
      console.error(error);
      toast.error("Failed to load activities ❌");
    } finally {
      setLoading(false);
    }
  };

  fetchActivities();
}, []);

  const allimages = [img1, img2, img3, img4, img5];

  return (
    <MainLayout>
      {/* 🌿 HERO */}
      <section className="min-h-[90vh] flex flex-col justify-center items-center text-center relative overflow-hidden">
        <motion.img
          src={logo}
          alt="Vandevrai Logo"
          className="
    w-32 
    sm:w-40 
    md:w-56 
    lg:w-72 
    xl:w-80 
    h-auto object-contain
    drop-shadow-[0_12px_35px_rgba(34,197,94,0.35)]
  "
          initial={{ opacity: 0, scale: 0.85 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8 }}
        />
        <motion.h1
          initial={{ opacity: 0, y: 80 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          className="text-5xl md:text-7xl font-extrabold text-green-900"
        >
          Rebuild Nature 🌿
        </motion.h1>

        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5 }}
          className="mt-6 text-lg text-green-800 max-w-2xl"
        >
          A movement to restore ecosystems and reconnect people with nature.
        </motion.p>
      </section>

      {/* 🌿 ABOUT */}
      <motion.section
        id="about"
        className="py-20"
        initial={{ opacity: 0, y: 60 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{
          duration: 1.2,
          ease: [0.22, 1, 0.36, 1], // smooth premium easing
        }}
        viewport={{ once: true, margin: "-100px" }}
      >
        <div className="bg-white/70 backdrop-blur-xl rounded-3xl p-6 shadow-xl">
          <Typography variant="h4" align="center">
            About Us 🌿
          </Typography>
          <p className="mt-6 text-green-800 text-center max-w-3xl mx-auto">
            Vandevrai Foundation is dedicated to restoring nature through tree
            plantation, biodiversity protection, and environmental awareness
            programs.
          </p>
        </div>
      </motion.section>

      {/* 🌍 IMPACT */}
      <motion.section
        className="py-20"
        initial={{ opacity: 0, y: 60 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{
          duration: 1.2,
          ease: [0.22, 1, 0.36, 1], // smooth premium easing
        }}
        viewport={{ once: true, margin: "-100px" }}
      >
        <div className="bg-white/70 backdrop-blur-xl rounded-3xl p-6 shadow-xl">
          <Typography variant="h4" align="center">
            Our Impact 🌍
          </Typography>

          <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {["10,000+ Trees", "50,000+ Seeds", "5,000+ People"].map(
              (item, i) => (
                <motion.div
                  key={i}
                  whileHover={{ scale: 1.05 }}
                  className="p-8 rounded-2xl bg-gradient-to-br from-green-100 to-lime-100 text-center"
                >
                  <h2 className="text-3xl font-bold text-green-900">{item}</h2>
                </motion.div>
              )
            )}
          </div>
        </div>
      </motion.section>

      {/* 🌱 ACTIVITIES */}
      <motion.section
        id="activities"
        className="py-20"
        initial={{ opacity: 0, y: 60 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{
          duration: 1.2,
          ease: [0.22, 1, 0.36, 1], // smooth premium easing
        }}
        viewport={{ once: true, margin: "-100px" }}
      >
        <div className="bg-white/70 backdrop-blur-xl rounded-3xl p-6 shadow-xl ">
          <Typography variant="h4" align="center">
            What We Do
          </Typography>

          <div className="mt-10  grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {activities.map((item, i) => (
              <motion.div
                key={i}
                whileHover={{ y: -10 }}
                onClick={() => handleOpen(item._id)}
                className={`p-6 cursor-pointer rounded-2xl bg-gradient-to-br shadow-lg shadow-purple-400`}
              >
                <h3 className="text-lg font-semibold">{item.name}</h3>
                <p className="text-green-800 text-sm mt-2">
                  {item.description}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </motion.section>

      {/* 📸 GALLERY (FIXED + RESPONSIVE) */}
      {/* 📸 GALLERY (FINAL FIX - NO GLITCH) */}
      <section id="gallery" className="py-24 overflow-hidden">
        <Typography variant="h4" align="center">
          Gallery 📸
        </Typography>

        <div className="mt-12 relative overflow-hidden group">
          {/* 🌫 Soft Fade Edges */}
          <div className="absolute left-0 top-0 h-full w-20 bg-gradient-to-r from-white via-white/80 to-transparent z-10 pointer-events-none" />
          <div className="absolute right-0 top-0 h-full w-20 bg-gradient-to-l from-white via-white/80 to-transparent z-10 pointer-events-none" />

          {/* 🌊 SCROLL TRACK */}
          <div className="flex gap-4 md:gap-6 w-max animate-marquee group-hover:[animation-play-state:paused]">
            {[...allimages, ...allimages].map((src, i) => (
              <div
                key={i}
                className="
            min-w-[170px] 
            sm:min-w-[220px] 
            md:min-w-[300px] 
            lg:min-w-[340px]
            h-32 sm:h-44 md:h-60 lg:h-72
            rounded-2xl overflow-hidden 
            shadow-lg 
            relative
            group/card
          "
              >
                {/* 🌿 IMAGE */}
                <img
                  src={src}
                  alt="gallery"
                  className="w-full h-full object-cover transition duration-700 ease-out group-hover/card:scale-110"
                />

                {/* 🌑 OVERLAY (DEPTH EFFECT) */}
                <div className="absolute inset-0 bg-black/10 group-hover/card:bg-black/0 transition duration-500" />

                {/* ✨ LIGHT REFLECTION */}
                <div className="absolute inset-0 opacity-0 group-hover/card:opacity-100 transition duration-700 bg-gradient-to-tr from-white/20 via-transparent to-transparent" />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 🌿 CTA */}
      <motion.section
        id="contact"
        className="py-24 text-center"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
      >
        <Typography variant="h4">Join the Green Revolution 🌱</Typography>
        <Button variant="contained" color="success" className="mt-6">
          Get Involved
        </Button>
      </motion.section>

      <Modal
        open={open}
        onClose={() => setOpen(false)}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        BackdropProps={{
          sx: {
            backgroundColor: "rgba(0,0,0,0.5)",
            backdropFilter: "blur(6px)",
          },
        }}
      >
        <Box
          component={motion.div}
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.4 }}
          sx={{
            width: "95%",
            maxWidth: "900px",
            height: "85vh", // 👈 fixed height for scroll
            borderRadius: "24px",
            overflow: "hidden",

            background: "rgba(255,255,255,0.85)",
            boxShadow: "0 25px 80px rgba(0,0,0,0.4)",
          }}
        >
          {/* 🌿 STICKY HEADER */}
          <Box
            sx={{
              position: "sticky",
              top: 0,
              zIndex: 10,
              p: 2,

              backdropFilter: "blur(20px)",
              background: "rgba(255,255,255,0.6)",

              borderBottom: "1px solid rgba(255,255,255,0.4)",
            }}
          >
            <Typography variant="h5" className="text-green-900">
              🌿 Activity Gallery
            </Typography>
          </Box>

          {/* 📸 SCROLLABLE CONTENT */}
          <Box
            sx={{
              overflowY: "auto",
              height: "calc(85vh - 70px)", // 👈 subtract header height
              p: 2,
            }}
          >
            {loading ? (
              <Box className="flex flex-col items-center justify-center h-full">
                <CircularProgress color="success" />
              </Box>
            ) : (
              <ImageList
                variant="masonry"
                cols={
                  window.innerWidth < 640 ? 1 : window.innerWidth < 900 ? 2 : 3
                }
                gap={12}
              >
                {images.map((img, i) => (
                  <ImageListItem key={i}>
                    <img
                      src={img.imageUrl}
                      alt="activity"
                      loading="lazy"
                      className="rounded-2xl object-cover w-full h-full hover:scale-105 transition duration-500"
                    />
                  </ImageListItem>
                ))}
              </ImageList>
            )}
          </Box>
        </Box>
      </Modal>
    </MainLayout>
  );
}
